import { render } from "./ArchiveSlider.vue?vue&type=template&id=3fb63454"
import script from "./ArchiveSlider.vue?vue&type=script&lang=js"
export * from "./ArchiveSlider.vue?vue&type=script&lang=js"

import "./ArchiveSlider.vue?vue&type=style&index=0&id=3fb63454&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__